module.exports = __webpack_public_path__ + "img/bonus_symbol_0.ecfdffc1.png";